import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=c544bfba&"
import script from "./MasterData.vue?vue&type=script&lang=js&"
export * from "./MasterData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports